export default __webpack_public_path__ + "static/media/Global Shop Solutions.804b9aa5.png";